// extracted by mini-css-extract-plugin
module.exports = {"cardHeader":"ParticipationList_cardHeader__30pak"};